import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { getFlight } from "../../store/flightDetails/selectors.js";
export function HelmetHeader(props) {
    const { children } = props;
    const flight = useSelector(getFlight);
    const title = useMemo(() => flight?.segments
        .map(({ departureAirport, arrivalAirport }) => `${departureAirport.cityName} - ${arrivalAirport.cityName}`)
        .join(" | "), [flight]);
    if (!flight?.segments?.length)
        return null;
    return (React.createElement(Helmet, null,
        React.createElement("title", null,
            title,
            " - Booking.com"),
        React.createElement("meta", { property: "webview:header", content: "regular" }),
        React.createElement("meta", { property: "webview:title", content: "" }),
        children));
}
